






























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import {
  ContentCampaignCollectionModel,
  ContentCampaignCollectionWithModel
} from '@/modules/content-campaign/models/content-campaign-collection.model'
import { CampaignStatus } from '@/modules/base-campaign/models/base-campaign-resource.model'
import { PanelContentCampaignRoute } from '@/modules/content-campaign/routes/panel-content-campaign.route'
import { PanelContentCampaignService } from '@/modules/content-campaign/services/panel-content-campaign.service'

@Component({
  components: {
    BaseButton
  }
})
export default class PanelContentCampaignActions extends Vue {
  constructor(
    private readonly routes: PanelContentCampaignRoute,
    private readonly service: PanelContentCampaignService
  ) {
    super()
  }

  @Prop() campaign!: ContentCampaignCollectionModel
  @Prop() withData!: ContentCampaignCollectionWithModel

  campaignStatus = CampaignStatus

  remove(id: number) {
    this.service.destroy(id)
  }

  private getCampaignLinkByState() {

    if (this.campaign.status === this.campaignStatus.DRAFT) {
      return this.campaign.step == 1 ?
        this.routes.getStepOne(this.campaign.id)
        : this.routes.getStepTwo(this.campaign.id)
    }
    return this.routes.show(this.campaign.id)
  }

}

